// Shapes
import { PerkShape } from "~shapes/perk"

export const isPerkActive = (perk: PerkShape): boolean => {
  return perk.status.toLowerCase() === "active"
}
